import cx from "classnames";
import { Field, Form, Formik } from "formik";

import { Button, Col, Divider, Flex, Modal, Radio, Row, Space, Spin } from "antd";
import { Input, Select } from "components/form";

import { t } from "i18next";
import styles from "./Modal.module.css";
import { useState } from "react";
import { HOST_TYPE } from "features/company/schemas/companySmtpSchema";

function ModalConfigMail({
  isLoading = false,
  title = "",
  type = 'Add',
  width = 975,
  className = "",
  isModalOpen = false,
  values = {},
  onTestConnent = () => { },
  onSubmit = () => { },
  handleCancel = () => { },
  testConnect = true,
  commonTypeByGroupType = []
}) {

  const [checkTestConnect, setCheckTestConnect] = useState(true)

  const hostCustomizeSetting = (values) => {
    let hostCustomize = "";
    switch (values.host) {
      case HOST_TYPE.GMAIL:
        hostCustomize = "smtp.gmail.com";
        break;
      case HOST_TYPE.HOTMAIL:
        hostCustomize = "smtp-mail.outlook.com";
        break;
      case HOST_TYPE.YAHOO:
        hostCustomize = "smtp.mail.yahoo.com";
        break;
      default:
        hostCustomize = values.hostCustomize;
    }
    return { ...values, hostCustomize }
  }
  return (
    <Modal
      destroyOnClose
      title={title}
      open={isModalOpen}
      onOk={handleCancel}
      onCancel={handleCancel}
      className={cx(styles.customStyle, className)}
      width={width}
      footer={null}
      closable={false}
      maskClosable={false}
    >
      <Spin spinning={isLoading}>
        <Formik
          enableReinitialize
          initialValues={{
            host: type === 'Add' ? HOST_TYPE.GMAIL : values.host ? values.host : '',
            port: type === 'Add' ? '587' : values.port ? values.port : '',
            username: type === 'Add' ? '' : values.username ? values.username : '',
            cc: type === 'Add' ? '' : values.cc ? values.cc : '',
            bcc: type === 'Add' ? '' : values.bcc ? values.bcc : '',
            password: type === 'Add' ? '' : values.password ? values.password : '',
            id: type === 'Add' ? '' : values.id ? values.id : '',
            hostCustomize: type === 'Add' ? '' : values.hostCustomize ? values.hostCustomize : '',
            typeName: type === 'Add' ? null : values.typeName ? values.typeName : null,
            actionMode: type
          }}
          onSubmit={(values) => {
            let newValues = hostCustomizeSetting(values)
            onSubmit({
              ...newValues,
            });
          }}
        >
          {({ resetForm = () => { }, values, handleChange, setFieldValue, setTouched }) => {
            const handleInputChange = (e) => {
              handleChange(e);
              setCheckTestConnect(true);
            };
            console.log("values.actionMode ", values);
            return (
              <Form>
                <Space
                  className={styles.container}
                  size={24}
                  direction="vertical"
                >
                  <Divider />
                  <Row gutter={[24, 12]}>
                    <Col span={type !== 'View' ? 12 : 12}>
                      <div className={cx(styles.container, className)}>
                        <label className={cx("label", styles.label)} htmlFor={"host"}>
                          {t('companyConfigMail.hostName')} {<span className="error">*</span>}
                        </label>
                      </div>
                      <Field name="registerType">
                        {({ meta }) => (
                          <div>
                            <Radio.Group
                              onChange={(e) => {
                                setFieldValue("host", e.target.value);
                                setTouched({}, false);
                              }}
                              value={values.host}
                              disabled={true}
                            >
                              <Radio value={HOST_TYPE.GMAIL}>
                                {t("Gmail")}
                              </Radio>
                              <Radio value={HOST_TYPE.HOTMAIL}>
                                {t("Hotmail")}
                              </Radio>
                              <Radio value={HOST_TYPE.YAHOO}>
                                {t("Yahoo")}
                              </Radio>
                              <Radio value={HOST_TYPE.CUSTOMIZED}>
                                {t("กำหนดเอง")}
                              </Radio>
                            </Radio.Group>
                            {meta.touched && meta.error && (
                              <div className="error">{meta.error}</div>
                            )}
                          </div>
                        )}
                      </Field>
                    </Col>
                    <Col span={type !== 'View' ? 12 : 12}>
                      <Input
                        name="port"
                        label={t("companyConfigMail.port")}
                        placeholder={t('companyConfigMail.port')}
                        size="large"
                        onChange={handleInputChange}
                        disabled={true}
                        required
                      />
                    </Col>
                    {values.host === HOST_TYPE.CUSTOMIZED &&
                      <Col span={type !== 'View' ? 12 : 12}>
                        <Input
                          name="hostCustomize"
                          label={t("companyConfigMail.hostCustomize")}
                          placeholder={t('companyConfigMail.hostCustomize')}
                          size="large"
                          onChange={handleInputChange}
                          disabled={type !== 'Add'}
                          required
                        />
                      </Col>
                    }
                    <Col span={type !== 'View' ? 12 : 12}>
                      <Input
                        name="username"
                        label={t("companyConfigMail.username")}
                        placeholder={t("companyConfigMail.username")}
                        size="large"
                        onChange={handleInputChange}
                        // disabled={type !== 'Add'}
                        required
                      />
                    </Col>
                    <Col span={type !== 'View' ? 12 : 12}>
                      <Input
                        name="password"
                        label={t("companyConfigMail.password")}
                        type="password"
                        placeholder={t("companyConfigMail.password")}
                        size="large"
                        onChange={handleInputChange}
                        required
                      />
                    </Col>
                    <Col span={24}>
                      <Select
                        name="typeName"
                        size="large"
                        label={t("companyConfigMail.typeName")}
                        placeholder={t('please-select-1')}
                        options={[commonTypeByGroupType]}
                        required
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        name="cc"
                        label={t("companyConfigMail.cc")}
                        placeholder={t('Ex.example-a-gmail-com-b-gmail-com-c-gmail-com')}
                        size="large"
                      />
                    </Col>
                    <Col span={12}>
                      <Input
                        name="bcc"
                        label={t("companyConfigMail.bcc")}
                        placeholder={t('Ex.example-a-gmail-com-b-gmail-com-c-gmail-com')}
                        size="large"
                      />
                    </Col>
                  </Row>
                  <Row justify="end">
                    <Space direction="horizontal" size={12}>
                      <Button
                        style={{ height: "40px", borderRadius: "8px", boxShadow: "none" }}
                        onClick={() => {
                          let newValues = hostCustomizeSetting(values)
                          console.log("🚀 ~ newValues:", newValues)
                          onTestConnent(newValues)
                          setCheckTestConnect(false)
                        }}
                      >
                        {t("companyConfigMail.testConnent")}
                      </Button>
                      <Button
                        style={{ height: "40px", borderRadius: "8px", boxShadow: "none" }}
                        onClick={() => {
                          handleCancel();
                          resetForm();
                        }}
                      >
                        {t("common.cancel")}
                      </Button>
                      <Button
                        htmlType="submit"
                        type="primary"
                        className={styles.submit}
                        disabled={(testConnect || checkTestConnect)}
                      >
                        {t("common.submit")}
                      </Button>
                    </Space>
                  </Row>
                </Space>
              </Form>
            );
          }}
        </Formik>
      </Spin>
    </Modal>
  );
}

export default ModalConfigMail;
